import { AxiosRequestConfig, AxiosResponse } from 'axios';

import Interceptor from '@/classes/Interceptor';

const interceptorRequest = (request: AxiosRequestConfig): AxiosRequestConfig => {
  return {
    ...request,
    baseURL: process.env.VUE_APP_MS_SQUARE_BASE_URL,
  };
};

const interceptorResponse = (response: AxiosResponse): AxiosResponse => {
  return response.data && response.data.data && response.data.data.content;
};

export default new Interceptor({ request: interceptorRequest, response: interceptorResponse });
